import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { PaymentMethod } from '@/services/reparoly/paymentApi';

export type PaymentMethodsState = {
  items: PaymentMethod[];
  lastFetchedAt: string | null;
};

const initialState: PaymentMethodsState = {
  items: [],
  lastFetchedAt: null,
};

const paymentMethodsSlice = createSlice({
  name: 'paymentMethods',
  initialState,
  reducers: {
    setPaymentMethods(
      state,
      action: PayloadAction<{ items: PaymentMethod[]; fetchedAt?: string }>,
    ) {
      state.items = action.payload.items || [];
      state.lastFetchedAt = action.payload.fetchedAt || new Date().toISOString();
    },
    resetPaymentMethods: () => initialState,
  },
});

export const { setPaymentMethods, resetPaymentMethods } = paymentMethodsSlice.actions;
export default paymentMethodsSlice.reducer;
